import { fromJS, Map } from 'immutable';
import getApiInstance from 'data/common/ApiCallGenerique';

const moment = require('moment-timezone');

export const loginUser = function(state, user) {
    if (user.timezone) moment.tz.setDefault(user.timezone);
    return fromJS(user);
};

export const logoutUser = function() {
    const apiInstance = getApiInstance();
    if (apiInstance) apiInstance.destroy();
    localStorage.removeItem('access_token');
    localStorage.removeItem('session');
    sessionStorage.removeItem('mixedContentNoticeIsClicked');

    return new Map();
};



// WEBPACK FOOTER //
// ./data/user/core.js